import React from 'react'

function StatusWithText(props) {
  return (
    <div
      className={`rounded-full px-3 py-1 ${props.status === "pending" ? "bg-amber-50 border border-amber-200" : props.status === "approved" ? "bg-green-50 border border-green-200" : "bg-red-50 border border-red-200"} flex items-center justify-center w-fit`}
    >
      <p className={`${props.status === "pending" ? "text-amber-700" : props.status === "approved" ? "text-green-700" : "text-red-700"} text-xs font-medium`}>
        {props.status}
      </p>
    </div>
  )
}

export default StatusWithText
